// extracted by mini-css-extract-plugin
module.exports = {"span":"UploadFileInput_span__3Vigc","fileNameSpan":"UploadFileInput_fileNameSpan__iga7n"};